import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { EntityWatcherCollection } from '../index'

export const setupEntityWatcherReplication = (
  collection: EntityWatcherCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'entitywatchers',
    displayName: 'EntityWatchers',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      entityType: doc.entityType,
      entityId: doc.entityId,
      userId: doc.userId,
      watchType: doc.watchType || 'manual',
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy ?? null,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      entityType: state.entityType,
      entityId: state.entityId,
      userId: state.userId,
      watchType: state.watchType,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn ?? null),
      deletedBy: state.deletedBy ?? null,
    }),
  })
